<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        <template v-if="isDelete">
          Удален комментарий курьеру
        </template>
        <template v-if="isAdd">
          Добавлен комментарий курьеру
        </template>
        <template v-if="isEdit">
          Изменён комментарий курьеру
        </template>
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>

      <user-info-label :user="item.user"/>
    </div>
    <div class="os-history-item__content">
      <template v-if="isDelete">
        <label-with-icon icon="comment-slash">
          {{ oldComment }}
        </label-with-icon>
      </template>
      <template v-if="isAdd">
        <label-with-icon icon="comment">
          {{ comment }}
        </label-with-icon>
      </template>
      <template v-if="isEdit">
        <before-after-log-item class-name="os-history-item__promocode-edit-item">
          <template v-slot:before>
            <label-with-icon icon="comment-slash">
              {{ oldComment }}
            </label-with-icon>
          </template>
          <template v-slot:after>
            <label-with-icon icon="comment">
              {{ comment }}
            </label-with-icon>
          </template>
        </before-after-log-item>
      </template>
    </div>
  </div>
</template>

<script>
  import UserInfoLabel
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'
  import LabelWithIcon
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/LabelWithIcon'
  import BeforeAfterLogItem
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/BeforeAfterLogItem'

  export default {
    name: 'HistoryItemTypeCourierComment',
    components: {
      BeforeAfterLogItem,
      LabelWithIcon,
      UserInfoLabel,
    },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      isDelete () {
        return this.oldComment !== null && this.comment === null
      },
      isAdd () {
        return this.oldComment === null && this.comment !== null
      },
      isEdit () {
        return this.oldComment !== null &&
          this.comment !== null &&
          this.oldComment !== this.comment
      },

      oldComment () {
        return this.item?.oldCourierComment
      },
      comment () {
        return this.item?.courierComment
      },
    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";
</style>
